export enum BookingSlotSelectPolicyEnum {
  None = 0,
  FirstSlot = 1,
  LastSlot = 2,
  NearestSlot = 3,
}
